<div class="closing-x-wrap">
    <mat-icon class="close-icon condenced" alt="Close dialog" (click)="close()"> close </mat-icon>
</div>
<h1 mat-dialog-title id="notes-title">{{ title }}</h1>

<div mat-dialog-content>
    <form [formGroup]="form">
        <mat-form-field appearance="fill" class="col">
            <mat-label>{{ label }}</mat-label>
            <textarea class="form-control" type="text" matInput formControlName="notes" autocomplete="off" maxlength="1000"></textarea>
            <mat-error>{{ label }} is required</mat-error>
        </mat-form-field>
    </form>
    <span class="note-length" [class.error]="this.form.controls.notes.value.length >= 1000">{{ this.form.controls.notes.value.length }}/1000</span>
</div>

<div class="form-footer" mat-dialog-actions>
    <button mat-button class="primary" (click)="submit()" [disabled]="this.form.invalid">Update</button>
</div>
